<!-- Search Settings Card -->
<div class="bgWhiteColor filters-shadow mb-2 flex flex-col gap-4 rounded-lg border border-gray-200 p-4">
  <!-- Filters Grid -->
  <div class="grid grid-cols-4 gap-4">
    <app-filter-item-search [label]="searchLabel()" [placeholder]="searchPlaceholder()" [(searchTerm)]="titleFilter" />

    <app-filter-item-search
      [label]="paymentTermLabel()"
      [placeholder]="paymentTermPlaceholder()"
      [(searchTerm)]="paymentTermFilter" />

    <app-filter-date-component
      [label]="createdOnFromLabel()"
      [(value)]="createdOnFrom"
      [isInvalid]="isCreatedDateRangeInvalid()" />

    <app-filter-date-component
      [label]="createdOnToLabel()"
      [(value)]="createdOnTo"
      [isInvalid]="isCreatedDateRangeInvalid()" />

    <app-filter-date-component
      [label]="modifiedOnFromLabel()"
      [(value)]="modifiedOnFrom"
      [isInvalid]="isModifiedDateRangeInvalid()" />

    <app-filter-date-component
      [label]="modifiedOnToLabel()"
      [(value)]="modifiedOnTo"
      [isInvalid]="isModifiedDateRangeInvalid()" />
  </div>

  <!-- Sort + Actions Row -->
  <div class="my-5 flex items-end justify-between border-t border-gray-200 pt-4">
    <app-filter-sorting-component
      [(orderBy)]="orderBy"
      [orderDir]="orderDir()"
      [sortOptions]="sortOptions()"
      (toggleOrder)="toggleOrder.emit()" />

    <div class="flex items-end gap-3">
      <button
        (click)="reset.emit()"
        class="borderPrimaryColor textPrimaryColor hover-bg-primary-10 rounded-md border px-5 py-1.5 text-sm font-medium hover:cursor-pointer">
        <span i18n="@@adminProductsResetButton">Clear</span>
      </button>
      <button
        (click)="onApply()"
        class="bgPrimaryColor hover-bg-primary-hover rounded-md px-5 py-1.5 text-sm font-medium text-white hover:cursor-pointer">
        <span i18n="@@adminCategoriesSubmitButton">Apply</span>
      </button>
    </div>
  </div>
</div>
